<template>
  <div class="page-scroll-container" ref="pageContainer" id="page6-container">
    <!-- 1. [底层] 清晰背景图 -->
    <img
      class="bg-layer clear-bg"
      src="../../../assets/annualReport/page6_cumulative_bac.png"
      alt="bg-clear"
    />

    <!-- 2. [中间层] 模糊背景图 -->
    <img
      class="bg-layer blur-bg"
      :class="{ active: isVisible }"
      src="../../../assets/annualReport/page6_blur.png"
      alt="bg-blur"
    />

    <!-- 3. [顶层] 核心视觉卡片 -->
    <div class="visual-card" :class="{ 'start-anim': isVisible }">
      <!-- 卡片底图 -->
      <div class="card-bg-container">
        <img
          class="card-img"
          src="../../../assets/annualReport/page6_cumulative_bac.png"
          alt="card-bg"
        />
      </div>

      <!-- Group 1: 果咖 -->
      <img
        src="../../../assets/annualReport/fruit_coffee.png"
        class="deco-img poster-1"
        alt="fruit-poster"
      />
      <div class="text-group text-1">
        <div>果咖季销量千万杯</div>
        <div>
          可让<span class="dynamic">10</span><span class="unit">万+</span>
        </div>
        <div>榨汁机集体退休</div>
      </div>

      <!-- Group 2: 奶茶 -->
      <img
        src="../../../assets/annualReport/milk_tea.png"
        class="deco-img poster-2"
        alt="milk-poster"
      />
      <div class="text-group text-2">
        <div>奶盖轻盈上新</div>
        <div>解锁多种隐藏喝法</div>
      </div>

      <!-- Group 3: 暖咖 -->
      <img
        src="../../../assets/annualReport/warm_coffee.png"
        class="deco-img poster-3"
        alt="warm-poster"
      />
      <div class="text-group text-3">
        <div>暖咖季爆品</div>
        <div>热度覆盖<span class="dynamic">18000</span>家门店</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page6Cumulative",
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },
  mounted() {
    document.body.classList.add("lock-scroll");
    const vm = this;
    vm.observer = new IntersectionObserver(
      ([entry]) => {
        // 使用解构直接获取第一个 entry
        if (entry.isIntersecting) {
          vm.isVisible = true;
        } else {
          vm.isVisible = false;
        }
      },
      { threshold: 0.2 }
    );

    if (vm.$refs.pageContainer) {
      vm.observer.observe(vm.$refs.pageContainer);
    }
  },
  beforeDestroy() {
    document.body.classList.remove("lock-scroll");
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
/* =========================================
   1. 基础容器与背景 (保持不变)
   ========================================= */
.page-scroll-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a;
}

.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  object-fit: cover;
}

.clear-bg {
  z-index: 0;
}
.blur-bg {
  z-index: 1;
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
  &.active {
    opacity: 1;
  }
}

/* =========================================
   2. 视觉卡片 (保持不变)
   ========================================= */
.visual-card {
  position: relative;
  z-index: 2;
  width: 100vw;
  height: 100vh;
  container-type: size;
  isolation: isolate;
  --unit: 1vw;
}

@media (min-aspect-ratio: 13/25) {
  .visual-card {
    height: 100vh;
    width: calc(100vh * 390 / 844);
    aspect-ratio: 390 / 844;
    --unit: 0.462vh;
  }
}
@media (max-aspect-ratio: 9/21) {
  .visual-card {
    width: 100vw;
    height: calc(100vw * 844 / 390);
    aspect-ratio: 390 / 844;
    --unit: 1vw;
  }
}

.card-bg-container {
  position: absolute;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;

  /* 关键：防止渲染闪烁或透视问题 */
  transform: translateZ(0);
  backface-visibility: hidden;
}
.card-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}

/* =========================================
   3. 元素布局与样式 (保持不变)
   ========================================= */
.deco-img {
  position: absolute;
  opacity: 0;
  transform-origin: center center;
  backface-visibility: hidden;
}
.poster-1 {
  top: 7.5%;
  left: 12%;
  width: 40%;
}
.poster-2 {
  top: 35.5%;
  left: 6%;
  width: 37%;
}
.poster-3 {
  top: 33%;
  right: 13%;
  width: 38%;
}

.text-group {
  position: absolute;
  opacity: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: calc(4 * var(--unit));
  font-weight: 600;
  white-space: nowrap;
  .dynamic {
    font-family: "MontserratRoman-SemiBold", sans-serif;
    font-weight: 600;
  }
}
.text-1 {
  top: 17.5%;
  right: 13%;
  color: #9b4f22;
  .dynamic {
    font-size: calc(6.1 * var(--unit));
    color: #ff9b25;
    position: relative;
    top: calc(0.3 * var(--unit)); /* 微调：正数向下移动，负数向上移动 */
  }
  .unit {
    color: #ff9b25;
  }
}
.text-2 {
  gap: calc(1.7 * var(--unit));
  bottom: 35.5%;
  left: 7%;
  color: #8d461c;
}
.text-3 {
  gap: calc(1.2 * var(--unit));
  bottom: 37%;
  right: 3%;
  color: #8d461c;
  .dynamic {
    font-size: calc(6.1 * var(--unit));
    color: #ff6969;
    position: relative;
    top: calc(0.3 * var(--unit)); /* 微调：正数向下移动，负数向上移动 */
  }
}

/* =========================================
   4. 动画逻辑 (调整为“快启慢收”)
   ========================================= */

/* 保持你满意的柔和角度 */
@keyframes poster3DFlipSoft {
  0% {
    opacity: 0;
    transform: perspective(1200px) rotateX(30deg) rotateY(20deg) scale(0.8)
      translateZ(-50px);
  }
  100% {
    opacity: 1;
    transform: perspective(1200px) rotateX(0) rotateY(0) scale(1) translateZ(0);
  }
}

@keyframes textFloatUp {
  from {
    opacity: 0;
    transform: translateY(calc(3 * var(--unit)));
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.start-anim {
  /* 
     核心修改点：
     1. 时长保持 2.5s (保证尾部足够慢)
     2. 曲线改为 cubic-bezier(0.23, 1, 0.32, 1)
        含义：在时间轴的前 20%~30%，动画进度就已经冲到了 100% 附近，
        剩下的 70% 时间都在做极其微小的归位调整。
  */

  // --- 第一组 ---
  .poster-1 {
    animation: poster3DFlipSoft 2.5s cubic-bezier(0.23, 1, 0.32, 1) forwards;
    animation-delay: 0.2s;
  }
  .text-1 {
    animation: textFloatUp 1.5s ease-out forwards;
    animation-delay: 0.6s; // 配合海报快速出现，稍微提前一点文字出现时间
  }

  // --- 第二组 ---
  .poster-2 {
    animation: poster3DFlipSoft 2.5s cubic-bezier(0.23, 1, 0.32, 1) forwards;
    animation-delay: 1.2s;
  }
  .text-2 {
    animation: textFloatUp 1.5s ease-out forwards;
    animation-delay: 1.6s;
  }

  // --- 第三组 ---
  .poster-3 {
    animation: poster3DFlipSoft 2.5s cubic-bezier(0.23, 1, 0.32, 1) forwards;
    animation-delay: 2.2s;
  }
  .text-3 {
    animation: textFloatUp 1.5s ease-out forwards;
    animation-delay: 2.6s;
  }
}
</style>
